import React, { useState } from 'react';
import { Form, Input, Button, Card, Typography, message, Alert } from 'antd';
import { LockOutlined, UserOutlined } from '@ant-design/icons';
import { useAuth } from '../../hooks/useAuth';

/** Текст ошибки входа для toast и Alert (дебаг на этапе разработки). */
function loginErrorText(e) {
  const status = e.response?.status;
  const detail = e.response?.data?.detail;

  if (!e.response) {
    return 'Нет связи с сервером';
  }
  if (typeof detail === 'string' && detail) {
    return detail;
  }
  if (status === 401) {
    return 'Неверный логин или пароль';
  }
  if (status === 429) {
    return 'Слишком много попыток. Подождите немного и попробуйте снова.';
  }
  if (status === 403) {
    return 'Аккаунт заблокирован';
  }
  if (status) {
    return `Ошибка входа (${status})`;
  }
  return 'Ошибка входа';
}

export default function Login() {
  const { login } = useAuth();
  const [loading, setLoading] = useState(false);
  const [formError, setFormError] = useState(null);

  const onFinish = async (values) => {
    setLoading(true);
    setFormError(null);
    try {
      await login(values.username, values.password);
      message.success('Вход выполнен');
    } catch (e) {
      const text = loginErrorText(e);
      setFormError(text);
      message.error(text);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', background: '#f0f2f5' }}>
      <Card style={{ width: 400 }}>
        <Typography.Title level={3} style={{ textAlign: 'center' }}>
          ЛОГИСТ
        </Typography.Title>
        <Typography.Text type="secondary" style={{ display: 'block', textAlign: 'center', marginBottom: 24 }}>
          Система управления доставками
        </Typography.Text>
        {formError && (
          <Alert
            type="error"
            showIcon
            message={formError}
            style={{ marginBottom: 16 }}
          />
        )}
        <Form onFinish={onFinish}>
          <Form.Item name="username" rules={[{ required: true, message: 'Введите логин' }]}>
            <Input prefix={<UserOutlined />} placeholder="Логин" size="large" />
          </Form.Item>
          <Form.Item name="password" rules={[{ required: true, message: 'Введите пароль' }]}>
            <Input.Password prefix={<LockOutlined />} placeholder="Пароль" size="large" />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" loading={loading} block size="large">
              Войти
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
}
